// ============================================
// SUBSCRIPTION REMINDER MODAL
// Muestra un modal cuando quedan 3 días o menos para que expire la suscripción
// ============================================

(function() {
    'use strict';

    const REMINDER_KEY = 'lastReminderShown';
    const REMINDER_DISMISSED_KEY = 'reminderDismissed';
    const SESSION_SHOWN_KEY = 'reminderShownThisSession'; // Nueva clave para sesión
    const DAYS_THRESHOLD = 3;

    /**
     * Verificar si el usuario necesita ver el recordatorio
     */
    function checkSubscriptionExpiry() {
        try {
            const userPlan = (localStorage.getItem('userPlan') || '').toLowerCase();
            const expiresAt = localStorage.getItem('expiresAt') ||
                              localStorage.getItem('userExpiresAt') ||
                              localStorage.getItem('accountExpires') ||
                              sessionStorage.getItem('accountExpires');
            const showOnLogin = sessionStorage.getItem('subscriptionReminderOnLogin') === '1';
            
            // Solo para usuarios con planes de pago
            if (!userPlan || userPlan === 'free' || !expiresAt) {
                return;
            }

            // Solo mostrar en el momento del login
            if (!showOnLogin) {
                return;
            }

            const expiryDate = new Date(expiresAt);
            const now = new Date();
            const daysLeft = Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24));

            // Solo mostrar si quedan 3 días o menos
            if (daysLeft > DAYS_THRESHOLD || daysLeft < 0) {
                return;
            }

            // ✅ NUEVO: Verificar si ya se mostró en esta sesión
            const shownThisSession = sessionStorage.getItem(SESSION_SHOWN_KEY);
            if (shownThisSession === expiresAt) {
                return; // Ya se mostró en esta sesión
            }

            // Verificar si ya se mostró hoy
            const lastShown = localStorage.getItem(REMINDER_KEY);
            const today = new Date().toDateString();
            
            if (lastShown === today) {
                return;
            }

            // Verificar si el usuario lo desestimó permanentemente
            const dismissed = localStorage.getItem(REMINDER_DISMISSED_KEY);
            if (dismissed === expiresAt) {
                return; // Ya lo desestimó para esta fecha de expiración
            }

            // Mostrar el modal después de 3 segundos
            setTimeout(() => {
                showReminderModal(daysLeft, userPlan, expiryDate);
            }, 3000);

        } catch (e) {

        }
    }

    /**
     * Mostrar el modal de recordatorio
     */
    function showReminderModal(daysLeft, userPlan, expiryDate) {
        const modal = document.getElementById('subscriptionReminderModal');
        if (!modal) {
            return;
        }

        // Actualizar contenido dinámico
        const daysElement = modal.querySelector('#reminderDaysLeft');
        const dateElement = modal.querySelector('#reminderExpiryDate');

        if (daysElement) {
            daysElement.textContent = daysLeft;
            daysElement.className = daysLeft <= 1 ? 'days-urgent' : 'days-warning';
        }

        if (dateElement) {
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            dateElement.textContent = expiryDate.toLocaleDateString('es-ES', options);
        }

        // Mostrar modal
        modal.classList.remove('hidden');
        modal.classList.add('flex');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');

        // ✅ Marcar como mostrado en esta sesión
        const expiresAt = localStorage.getItem('expiresAt') ||
                  localStorage.getItem('userExpiresAt') ||
                  localStorage.getItem('accountExpires') ||
                  sessionStorage.getItem('accountExpires');
        sessionStorage.setItem(SESSION_SHOWN_KEY, expiresAt);
        sessionStorage.removeItem('subscriptionReminderOnLogin');
        
        // Marcar como mostrado hoy
        localStorage.setItem(REMINDER_KEY, new Date().toDateString());

        // ✅ Crear notificación en campana
        if (window.NotificationCenter && typeof window.NotificationCenter.add === 'function') {
            try {
                window.NotificationCenter.add({
                    type: 'warning',
                    title: 'Suscripci\u00f3n por expirar',
                    message: `Tu suscripci\u00f3n expira en ${daysLeft} d\u00eda${daysLeft > 1 ? 's' : ''}. Renueva para mantener acceso completo.`,
                    action: () => {
                        window.location.href = '/perfil?tab=billing';
                    }
                });
            } catch (e) {}
        }
    }

    /**
     * Cerrar el modal
     */
    window.closeReminderModal = function() {
        const modal = document.getElementById('subscriptionReminderModal');
        if (modal) {
            modal.classList.add('hidden');
            modal.classList.remove('flex');
            modal.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('overflow-hidden');
        }
    };

    /**
     * Usuario va a gestionar facturación en profile
     */
    window.handleReminderGoToProfile = function() {
        closeReminderModal();
        
        // Si ya estamos en profile, solo activar la sección
        if (window.location.pathname.includes('/perfil')) {
            const billingBtn = document.querySelector('.profile-nav-item[data-section="billing"]');
            if (billingBtn) {
                billingBtn.click();
            }
        } else {
            // Si estamos en otra página, redirigir
            window.location.href = '/perfil?tab=billing';
        }
    };

    /**
     * Usuario desestima por ahora
     */
    window.handleReminderDismiss = function() {
        closeReminderModal();
        
        if (window.showAlert) {
            window.showAlert('Recordatorio guardado', 'Te lo volveremos a recordar mañana.', 'info');
        }
    };

    /**
     * Usuario no quiere ver más recordatorios
     */
    window.handleReminderDismissForever = function() {
        const expiresAt = localStorage.getItem('expiresAt') || localStorage.getItem('userExpiresAt');
        if (expiresAt) {
            localStorage.setItem(REMINDER_DISMISSED_KEY, expiresAt);
        }
        
        closeReminderModal();
        
        if (window.showAlert) {
            window.showAlert('Recordatorios desactivados', 'No te mostraremos más avisos para esta expiración.', 'info');
        }
    };

    // Inicializar cuando el DOM esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkSubscriptionExpiry);
    } else {
        checkSubscriptionExpiry();
    }

})();
